import axios from "axios";
import { Global } from "../utils/general";
import headerRequest from "../utils/headers";

const API_URL = Global.url;

class MaintenanceService {
  getEquipmentMaintenance(url, id) {
    const ruta = `${API_URL}/mantenimiento/equipo/${id}?url=${url}`;
    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }
  createMaintenance(url, body) {
    const ruta = `${API_URL}/mantenimiento?url=${url}`;
    return axios
      .post(ruta, body, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  /* deleteEquipment(url, id) {
    const ruta = `${API_URL}/equipment/${id}?url=${url}`;
    return axios
      .delete(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }*/

  getMaintenanceTypes(url) {
    const ruta = `${API_URL}/mantenimiento/maintenanceTypes?url=${url}`;
    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  uploadMaintenanceExcel(url, file) {
    const ruta = `${API_URL}/mantenimiento/import-excel?url=${url}`;
    const formData = new FormData();
    formData.append("file", file);

    return axios
      .post(ruta, formData, {
        headers: {
          ...headerRequest(),
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((error) => {
        return error;
      });
  }

  generateMaintenancePDF(url, body) {
    const ruta = `${API_URL}/mantenimiento/generate-pdf?url=${url}`;
    return axios
      .post(ruta, body, {
        headers: headerRequest(),
        responseType: "blob",
      })
      .catch((error) => {
        return error;
      });
  }

  getPreguntas(url, id) {
    const ruta = `${API_URL}/mantenimiento/preguntas/${id}?url=${url}`;
    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  getDetalle(url, id) {
    const ruta = `${API_URL}/mantenimiento/detalle/${id}?url=${url}`;
    return axios.get(ruta, {
      headers: headerRequest(),
    });
  }

  uploadFirmado(url, formData) {
    const ruta = `${API_URL}/mantenimiento/upload-firmado?url=${url}`;

    return axios
      .post(ruta, formData, {
        headers: {
          ...headerRequest(),
          "Content-Type": "multipart/form-data",
        },
      })
      .catch((error) => {
        return error;
      });
  }

  getParametros(url) {
    const ruta = `${API_URL}/mantenimiento/parametros?url=${url}`;
    return axios
      .get(ruta, {
        headers: headerRequest(),
      })
      .catch((error) => {
        return error;
      });
  }

  uploadFotos(url, formData) {
    const ruta = `${API_URL}/mantenimiento/upload-fotos?url=${url}`;
    return axios.post(ruta, formData, {
      headers: {
        ...headerRequest(),
        "Content-Type": "multipart/form-data",
      },
    });
  }

  deleteFoto(url, id) {
    const ruta = `${API_URL}/mantenimiento/foto/${id}?url=${url}`;
    return axios.delete(ruta, {
      headers: headerRequest(),
    });
  }
}

export default new MaintenanceService();
